import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["disableItemProcessors"];
/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { useItems } from '../hooks/itemsHelper';
export const WixProGalleryWithItemProcessing = Gallery => props => {
  const disableItemProcessors = props.disableItemProcessors,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const _useItems = useItems(props.disableItemProcessors ? [] : props.items, props.itemsSrc),
    itemsToRender = _useItems.itemsToRender;
  const galleryProps = _extends({}, rest, {
    items: props.disableItemProcessors ? props.items : itemsToRender
  });
  return /*#__PURE__*/React.createElement(Gallery, galleryProps);
};
//# sourceMappingURL=withItems.js.map